import { render, staticRenderFns } from "./tag-manage.vue?vue&type=template&id=b743387c&scoped=true"
import script from "./tag-manage.vue?vue&type=script&lang=js"
export * from "./tag-manage.vue?vue&type=script&lang=js"
import style0 from "./tag-manage.vue?vue&type=style&index=0&id=b743387c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b743387c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b743387c')) {
      api.createRecord('b743387c', component.options)
    } else {
      api.reload('b743387c', component.options)
    }
    module.hot.accept("./tag-manage.vue?vue&type=template&id=b743387c&scoped=true", function () {
      api.rerender('b743387c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/tag-manage.vue"
export default component.exports